<template>
  <div class="promotion-item">
    <div class="main">
      <div>
        <div class="promotion-item-publication">
          {{ info.issuedOn | fullDate }}
        </div>

        <div class="promotion-item-title">
          {{ info.name }}
        </div>

        <div class="promotion-item-date">
          <span v-if="isCoupon">
            Срок действия промокода: {{ info.dateBegin | fullDate }} - {{ info.dateEnd | fullDate }}.
          </span>
          <span v-else>
            от {{ info.dateBegin | fullDate }}
          </span>

          <template v-if="info.description">
            <vue-client-only>
              <hint-block
                v-if="adaptive.isMobile"
                title="Подробнее"
                :description="info.description"
              />
              <div
                v-else
                @click="descriptionOpened = !descriptionOpened"
              >
                Подробнее
                <chevron-animated
                  :reverse="descriptionOpened"
                />
              </div>
            </vue-client-only>
          </template>
        </div>
      </div>

      <ui-button
        v-if="isCoupon"
        wide
        class="promo-button"
        :text="info.id"
        :icon="$options.icons.IconCopy.id"
        @click="copyCode"
      />
    </div>

    <vue-client-only>
      <div
        v-if="!adaptive.isMobile"
        :class="['promotion-item-description', {opened: descriptionOpened}]"
      >
        {{ info.description || '' }}
      </div>
    </vue-client-only>
  </div>
</template>

<script>
import VueClientOnly from 'vue-client-only';
import IconCopy from '../../assets/icons/copy.svg';
import ChevronAnimated from '../../assets/icons/chevron-animated';
import HintBlock from '../kit/hint-block/hint-block';

export default {
  name: 'promotion-item',

  components: {
    HintBlock,
    ChevronAnimated,
    VueClientOnly
  },

  inject: ['adaptive'],

  icons: {
    IconCopy
  },

  props: {
    info: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      descriptionOpened: false
    }
  },

  computed: {
    isCoupon() { // в будущем возможно перепривяжемся к др. параметру
      return !!this.info.id;
    }
  },

  methods: {
    copyCode() {
      const el = document.createElement('textarea');
      el.value = this.info.id;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.$store.dispatch('notifications/create', {
        title: 'Промокод скопирован',
        type: 'success',
      });
    }
  }
};
</script>

<style lang="scss">
.promotion-item {
  padding: 12px 12px 14px;
  margin-top: 16px;
  border: 1px solid $gray_lu;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .04), 0 8px 24px rgba(0, 0, 0, .03), 0 16px 32px rgba(0, 0, 0, .02);
  border-radius: 4px;

  &:first-child {
    margin-top: 20px;
  }

  .promotion-item-title {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }

  .promotion-item-date {
    margin-top: 4px;

    & > span {
      display: block;
      width: 200px;
    }
  }

  .hint-block .title {
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: $blue;

    svg {
      width: 16px;
      height: 16px;
      color: $blue;
    }
  }

  .promotion-item-publication,
  .promotion-item-description {
    color: $gray;
  }

  .promotion-item-publication,
  .promotion-item-date,
  .promotion-item-description {
    font-size: 12px;
    line-height: 16px;

    svg {
      width: 16px;
      height: 16px;
      color: $blue;
    }
  }

  .promo-button {
    height: 40px;
    margin-top: 30px;

    svg {
      margin-right: 4px;
    }
  }
}

@include breakpoint("tablet") {
  .promotion-item {
    display: flex;
    flex-direction: column;
    padding: 12px;

    .main {
      display: flex;
      justify-content: space-between;
    }

    .promotion-item-date {
      display: flex;

      & > div {
        display: flex;
        align-items: center;
        color: $blue;
      }

      & > div,
      svg {
        margin-left: 5px;
      }

      & > span {
        width: auto;
      }
    }

    .promotion-item-description {
      overflow: hidden;
      height: 0;

      &.opened {
        margin-top: 8px;
        height: auto;
      }
    }

    .promo-button {
      margin-top: 0;
      max-width: 220px;

      svg {
        margin-right: 5px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .promotion-item {
    padding: 20px;

    .promotion-item-title {
      font-size: 20px;
      line-height: 28px;
    }

    .promotion-item-title,
    .promotion-item-date {
      margin-top: 8px;
    }

    .promotion-item-publication,
    .promotion-item-date,
    .promotion-item-description {
      font-size: 14px;
      line-height: 20px;
    }

    .promotion-item-date {
      & > div {
        cursor: pointer;
      }
    }

    .promo-button {
      height: 56px;
      max-width: 240px;
      font-size: 16px;

      svg {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
    }
  }
}
</style>